import React from 'react';
import { Box, Typography } from '@mui/material';

const QuickLinkCard = ({ titleLines, background, rightIcon, onClick, iconGap = 0.5, subtitle, leftIcon, height = 104 }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height,
        borderRadius: 5,
        background,
        color: '#ffffff',
        px: '20px',
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          width: '100%',
        }}
      >
        {leftIcon && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {leftIcon}
          </Box>
        )}

        <Box sx={{ flex: 1 }}>
          {titleLines?.map((line, index) => {
            if (typeof line === 'string' && line.includes('Manila701')) {
              const parts = line.split('Manila701');
              return (
                <Typography 
                  key={index} 
                  variant="subtitle1" 
                  sx={{ fontWeight: 700, lineHeight: 1.2, fontSize: 18 }}
                  component="div"
                >
                  {parts.map((part, i) => (
                    <React.Fragment key={i}>
                      {part}
                      {i < parts.length - 1 && (
                        <span translate="no" style={{ fontFamily: 'inherit' }}>Manila701</span>
                      )}
                    </React.Fragment>
                  ))}
                </Typography>
              );
            }
            
            return (
              <Typography 
                key={index} 
                variant="subtitle1" 
                sx={{ fontWeight: 700, lineHeight: 1.2, fontSize: 18 }}
              >
                {line}
              </Typography>
            );
          })}

          {subtitle && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body2" sx={{ opacity: 0.85 }}>{subtitle}</Typography>
              {rightIcon && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ml: iconGap,
                  }}
                >
                  {rightIcon}
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {!subtitle && rightIcon && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: iconGap,
          }}
        >
          {rightIcon}
        </Box>
      )}
    </Box>
  );
};

export default QuickLinkCard;
